var _style, _defs, _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33 34",
    style: {
      enableBackground: "new 0 0 33 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000109714709441601565420000002929846891183670409_);}\r\n\t.st1{fill:none;stroke:#F7931A;}\r\n\t.st2{fill:#F7931A;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.5,
    y: 1,
    width: 32,
    height: 32
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000035489945589248049560000010719416176664507548_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000035489945589248049560000010719416176664507548_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M32,17c0,8.6-6.9,15.5-15.5,15.5S1,25.6,1,17S7.9,1.5,16.5,1.5S32,8.4,32,17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M0.5,32.5"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.7,11.8c0.4,0,0.8-0.1,1.1-0.2c0.3-0.1,0.6-0.2,0.9-0.3c0,0,0,0,0.1,0c0,0,0,0.1,0,0.1 c-0.5,0.7-1.1,1.3-1.8,1.8c0,0,0,0,0,0c0,0,0,0,0,0.1c0,0.4,0,0.8,0,1.2c-0.1,1.5-0.5,3-1.2,4.3c-0.5,0.9-1,1.7-1.7,2.4 c-0.9,1-2,1.8-3.2,2.4c-0.8,0.4-1.6,0.6-2.5,0.8c-0.4,0.1-0.9,0.1-1.3,0.2c-0.5,0-1,0-1.5,0c-0.6,0-1.3-0.1-1.9-0.3 c-0.9-0.2-1.8-0.5-2.6-0.9c-0.3-0.1-0.5-0.3-0.8-0.5c0,0,0,0,0,0c2.1,0.2,4-0.3,5.6-1.6c-0.8,0-1.5-0.3-2.2-0.8 C10,20,9.5,19.4,9.2,18.6c0.6,0.1,1.1,0.1,1.7-0.1c-0.9-0.2-1.6-0.6-2.2-1.4c-0.6-0.7-0.8-1.5-0.8-2.4C8.4,15,9,15.2,9.6,15.2 C8.5,14.4,8,13.4,7.9,12c0-0.7,0.2-1.3,0.5-1.9c0.6,0.8,1.4,1.5,2.2,2.1c0.8,0.6,1.7,1,2.7,1.4c1,0.3,1.9,0.5,3,0.6 c0-0.1,0-0.1,0-0.1c-0.1-0.4-0.1-0.8,0-1.2c0.1-0.6,0.3-1.2,0.6-1.7c0.5-0.8,1.3-1.4,2.3-1.6c0.3-0.1,0.7-0.1,1-0.1 c1,0,1.9,0.4,2.7,1.2c0,0,0.1,0.1,0.1,0c0.8-0.2,1.5-0.4,2.2-0.8c0,0,0.1,0,0.1-0.1c0,0,0,0,0,0c-0.1,0.2-0.2,0.4-0.3,0.6 C24.7,10.9,24.3,11.4,23.7,11.8C23.7,11.8,23.7,11.8,23.7,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.7,11.8C23.7,11.8,23.7,11.8,23.7,11.8C23.7,11.8,23.7,11.8,23.7,11.8C23.6,11.8,23.7,11.8,23.7,11.8 C23.7,11.8,23.7,11.8,23.7,11.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M25.3,9.7C25.3,9.7,25.3,9.7,25.3,9.7C25.3,9.7,25.3,9.7,25.3,9.7C25.3,9.7,25.3,9.7,25.3,9.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0557fb8df9fc3465459cb4c0411f9357.svg";
export { ForwardRef as ReactComponent };